<template>
    <div class="table-responsive has-options">
        <b-table hover :items="bases.data" :fields="fields" id="abonados-table">
            <template #cell(activo)></template>
            <template #cell(opciones)="{ item }">
                <OpcionesDropdownComponent v-bind:options="[
                    { to: { name: 'back.bases.show', params: { base_id: item.id, lista_id: lista_id }}, label: 'Ver'},
                    ... item.user_id ?
                        [{ to: { name: 'back.usuarios.show-user', params: { lista_id: lista_id, user_id: item.user_id }}, label: 'Ver usuario'}]
                    : [],
                    { to: { name: 'back.bases.update', params: { base_id: item.id, lista_id: lista_id }}, label: 'Editar'},
                    { type: 'action', action:() => showModal('enviar-' + item.id), label: 'Enviar'},
                    ... item.activo ? [
                        { type: 'action', action:() => showModal('anular-' + item.id), label: 'Realizar devolución'},
                    ] : [
                        { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'}
                    ],
                    { type: 'url', url: item.url_recibo, label: 'Imprimir recibo'}
                ]"/>

                <EnviarBase :base="item" @close="closeModal"></EnviarBase>
                <AnularBase :base="item" @close="closeModal" @actualizado="actualizar"></AnularBase>
                <BorrarModalComponent
                    :name="'borrar-' + item.id"
                    :title="'Borrar deportista ' + item.nombre"
                    confirmButton="¿Está segur@ de borrar este deportista?"
                    v-on:close="() => closeModal('borrar-' + item.id)"
                    v-on:confirm="() => borrarDeportista(item.id)"
                >
                </BorrarModalComponent>
            </template>
            <template #cell(tipo)="{ item }">{{ item.metodo_pago == 5 ? 'ONLINE' : 'TAQUILLA' }}</template>
        </b-table>
    </div>
</template>

<script>
import OpcionesDropdownComponent from "@/components/backend/components/OpcionesDropdownComponent";
import EnviarBase from '../modals/EnviarBase.vue';
import AnularBase from '../modals/AnularBase.vue';
import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"

export default {
    props: ['bases', 'lista_id'],
    data() {
        return {
            loading: false,
            fields: [
                { key: 'activo', label: '', tdClass: this.estaRenovadoCellClass },
                { key: "id", label: "ID"},
                { key: "nombre", label: "Nombre" },
                { key: "apellidos", label: "Apellidos" },
                { key: "dni", label: "DNI" }, 
                { key: "email", label: "Email" },
                { key: "tipo", label: "Tipo" },
                { key: "opciones", label: "Opciones", class: 'text-center' }
            ],
        }
    },
    methods: {
        showModal(modal) {
            this.$modal.show(modal);
        },
        actualizar() {
            this.$emit('actualizado');
        },
        closeModal(modal) {
            this.$modal.hide(modal);
        },
        estaRenovadoCellClass(value, key, item) {
            switch (value) {
            case 1:
                return 'bg-green';

            default:
                return 'bg-red';
            }
        },
        borrarDeportista(base_id) {
            const params = {
                filters : {},
                base_id: base_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.bases.borrar'), params).then(res => {
                this.$toast.success(res.data.message);
                this.actualizar();
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
            this.closeModal('borrar-' + base_id);
        }
    },
    components: {
        OpcionesDropdownComponent, EnviarBase, AnularBase, BorrarModalComponent
    }
}

</script>